<template>
  <div class="body con-wd">
    <breadcrumb :data="['项目', '编辑档案']"></breadcrumb>

    <div class="container">
      <el-row>
        <el-col :span="12" class="info-title">项目信息</el-col>
        <el-col :span="12" :style="{ textAlign: 'right' }">
          <el-button @click="handleEditProject" type="danger" icon="el-icon-edit">编辑项目</el-button>
        </el-col>
      </el-row>

      <div class="proj-con">
        <el-descriptions :column="3">
          <el-descriptions-item label="客户名称">{{
              projectInfo.customerName
            }}</el-descriptions-item>
          <el-descriptions-item label="项目名称">{{
              projectInfo.projectName
            }}</el-descriptions-item>
          <el-descriptions-item label="所在省市">{{ projectInfo.province }}-{{
              projectInfo.city
            }}</el-descriptions-item>
          <el-descriptions-item label="商机号/报价号">{{
              projectInfo.quote
            }}</el-descriptions-item>
          <el-descriptions-item label="备注">{{ projectInfo.remark }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <el-row>
        <el-col :span="14" style="margin-top: 0px" class="info-title">
          项目档案填写
        </el-col>
      </el-row>
      <div class="edit">
        <el-form :model="form" ref="form" class="form">
          <el-form-item label="业态" prop="type">
            <el-input v-model="form.type" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="直梯台数">
            <el-input v-model="form.straightCount" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="扶梯台数">
            <el-input v-model="form.escalatorsCount" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="直梯提升高度范围（米）">
            <el-input v-model="form.straightRaisedHigh" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="扶梯提升高度范围（米）">
            <el-input v-model="form.escalatorsRaisedHigh" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="直梯梯种规格">
            <el-input v-model="form.straightTrapezoidalSpecification" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="扶梯梯种规格">
            <el-input v-model="form.escalatorsTrapezoidalSpecification" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="直梯最高速度（米/秒）">
            <el-input v-model="form.straightSpeed" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="扶梯速度（米/秒）">
            <el-input v-model="form.escalatorsSpeed" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="项目最早验收时间">
            <el-date-picker
              v-model="form.receiveCertificatesTime"
              type="datetime"
              placeholder="选择日期时间"
              :picker-options="pickerOptions"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
            style="width: 378px">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否在保">
            <el-radio-group v-model="form.inPaul" style="width: 800px">
              <el-radio label="是" @click.native.prevent="onRadioChange('是')">三包期内</el-radio>
              <el-radio label="否" @click.native.prevent="onRadioChange('否')">三包期外</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="中标通知书" class="zhong">
            <Fileupload :data="form.file" ref="file"></Fileupload>
          </el-form-item>
          <el-form-item label="验收报告" class="zhong">
            <fileupload :data="form.fileEp" ref="fileEp"></fileupload>
          </el-form-item>
          <el-form-item label="合同扫描件" class="zhong">
            <fileupload :data="form.fileCopy" ref="fileCopy"></fileupload>
          </el-form-item>
          <el-form-item label="项目图片"></el-form-item>
          <el-form-item label="其他素材"></el-form-item>

          <el-form-item class="upload" style="margin-top: -20px">
            <Upload :data="form.fileImg" ref="fileImg"></Upload>
          </el-form-item>

          <el-form-item class="upload" style="margin-top: -20px">
            <Upload :data="form.fileMate" ref="fileMate"></Upload>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: right;padding-bottom: 20px">
        <el-button @click="goOut">上一步</el-button>
        <el-button type="primary" @click="getCreateOrUpdate">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Upload from '@/components/pc/Upload'
import Fileupload from '@/components/pc/Fileupload'
import Breadcrumb from '@/components/pc/Breadcrumb'

import { mapMutations } from 'vuex'
export default {
  name: 'projectEditing',
  components: {
    Breadcrumb,
    Upload,
    Fileupload
  },
  data() {
    return {
      businessId: null,
      projectInfo: {
        customerName: '', //客户
        projectName: '', //项目
        province: '', //省份
        city: '', //城市
        quote: '', //报价号
        coverUrl: '', //封面图片
        createTime: ''
      },
      uploadLoading: false,
      downloading: false,
      list: [],
      copyTaskId: null,
      upload:'',
      form:{
        type:'',
        num:'',
        height:'',
        specifications:'',
        id:'',
        unitsCount:'',
        straightCount:'',
        escalatorsCount:'',
        straightTrapezoidalSpecification:'',
        escalatorsTrapezoidalSpecification:'',
        escalatorsRaisedHigh:'',
        straightRaisedHigh:'',
        straightSpeed:'',
        escalatorsSpeed:'',
        inPaul:'',
        file:[],
        fileEp:[],
        fileCopy:[],
        fileImg:[],
        fileMate:[],
        receiveCertificatesTime: ''
      },
      fileList:[],
      pickerOptions: {
        // 设置禁用状态，参数为当前日期
        disabledDate(time) {
          // return time.getTime() < Date.now(); //当天不可选
          return time.getTime() < Date.now() - 86400000 //  - 86400000是否包括当天
        },
        // 控制时分秒不可选
        selectableRange: '00:00:00 - 23:59:59'
      }
    }
  },
  watch: {
    'form.receiveCertificatesTime'(selectTime) {
        var y = new Date().getFullYear()
        var m = new Date().getMonth()+1;
        var d = new Date().getDate();
        var h = new Date().getHours();
        var i = new Date().getMinutes();
        if(m<10){
          m = '0'+ m
        }
        if(h<10){
          h = '0'+h
        }
        if(d<10){
          d = '0'+d
        }
        if(i<10){
          i = '0'+i
        }
        var data = y+'-'+m+'-'+d+' '+h+':'+i
        if (new Date(selectTime).getTime() < new Date(data).getTime()) {
          const data = new Date()
          const hour = data.getHours()
          const minute = data.getMinutes()
          const second = data.getSeconds()
          this.$set(this.pickerOptions, 'selectableRange', `${hour}:${minute}:${second} - 23:59:59`)
        } else {
          this.$set(this.pickerOptions, 'selectableRange', '00:00:00 - 23:59:59')
        }
    }
  },
  mounted() {
    localStorage.removeItem('Checklist')
    this.changeMenuStatus({ value: 1 })
    this.businessId = this.$route.params.id
    this.getBusinessInfo()
    this.getDocumentTaskList()
    this.getProject()
  },
  methods: {
    onRadioChange(e) {
      // 当点击已经选中的把 radio 置空，就是取消选中，并返回
      if (this.form.inPaul === e) {
        this.form.inPaul = null
        return
      }
      // 不是选中，选中当前点击 Radio
      this.form.inPaul = e
    },
    getProject(){
      this.$request.getProject(this.businessId).then(res=>{
        if(res.data.personalOfficefile){
          this.form.type = res.data.personalOfficefile.businessType
          this.form.num = res.data.personalOfficefile.unitsCount
          this.form.height = res.data.personalOfficefile.hignRange
          this.form.specifications = res.data.personalOfficefile.trapezoidalSpecification
          this.form.id = res.data.personalOfficefile.id
          this.form.straightCount = res.data.personalOfficefile.straightCount
          this.form.escalatorsCount = res.data.personalOfficefile.escalatorsCount
          this.form.straightTrapezoidalSpecification = res.data.personalOfficefile.straightTrapezoidalSpecification
          this.form.escalatorsTrapezoidalSpecification = res.data.personalOfficefile.escalatorsTrapezoidalSpecification
          this.form.escalatorsRaisedHigh = res.data.personalOfficefile.escalatorsRaisedHigh
          this.form.straightRaisedHigh = res.data.personalOfficefile.straightRaisedHigh
          this.form.straightSpeed = res.data.personalOfficefile.straightSpeed
          this.form.escalatorsSpeed = res.data.personalOfficefile.escalatorsSpeed
          this.form.inPaul = res.data.personalOfficefile.inPaul
          this.form.receiveCertificatesTime = res.data.personalOfficefile.receiveCertificatesTime
        }
        if(res.data.bidNotices.length){
          res.data.bidNotices.forEach(item=>{
            item.show = true
          })
        }
        this.form.file = res.data.bidNotices

        if(res.data.acceptReports.length){
          res.data.acceptReports.forEach(item=>{
            item.show = true
          })
        }
        this.form.fileEp = res.data.acceptReports

        if(res.data.images.length){
          res.data.images.forEach(item=>{
            item.url = item.fileUrl
            item.show = true
          })
        }
        this.form.fileImg = res.data.images

        if(res.data.otherMaterials.length){
          res.data.otherMaterials.forEach(item=>{
            item.url = item.fileUrl
            item.show = true
          })
        }
        this.form.fileMate = res.data.otherMaterials

        if(res.data.contractScaners.length){
          res.data.contractScaners.forEach(item=>{
            item.url = item.fileUrl
            item.show = true
          })
        }
        this.form.fileCopy = res.data.contractScaners
      })
    },
    getFileFromUrl(url, fileName) {
      return new Promise((resolve, reject) => {
        var blob = null;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.setRequestHeader('Accept', 'xlxs');
        xhr.responseType = "blob";
        // 加载时处理
        xhr.onload = () => {
          // 获取返回结果
          blob = xhr.response;
          let file= new File([blob], fileName, { type: 'image/png' });
          // 返回结果
          resolve(file);
        };
        xhr.onerror = (e) => {
          reject(e)
        };
        // 发送
        xhr.send();
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      this.text = file.name
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    ...mapMutations(['changeMenuStatus']),
    goOut(){
      this.$router.go(-1)
    },
    handleEditProject() {
      this.$router.push(`/manage/editproject/${this.businessId}`)
    },
    getDocumentTaskList() {
      this.$request.getDocumentTaskList(this.businessId).then((res) => {
        if (res.code == 200) {
          this.list = res.data
        }
      })
    },
    getBusinessInfo() {
      this.$request.getBusinessInfo(this.businessId).then((res) => {
        if (res.code == 200) {
          this.projectInfo = res.data
        }
      })
    },
    handleNewProject() {
      this.$router.push(`/manage/newproject/${this.businessId}/${this.copyTaskId}`)
    },
    getCreateOrUpdate(){
      let bidNotices = this.uploadFiles('file')
      let acceptReports = this.uploadFiles('fileEp')
      let contractScaners = this.uploadFiles('fileCopy')
      let images = this.uploadFiles('fileImg')
      let otherMaterials = this.uploadFiles('fileMate')
      Promise.all([bidNotices,acceptReports,contractScaners,images,otherMaterials]).then(arr => {
        console.log(arr)
        // 保存
        if(!this.form.id){
          this.form.id = null
        }
        const data = {
          personalOfficefile:{
            id: this.form.id,
            bid: Number(this.businessId),
            businessType: this.form.type, //业态类型
            unitsCount: Number(this.form.straightCount) + Number(this.form.escalatorsCount),
            straightCount: Number(this.form.straightCount),
            escalatorsCount: Number(this.form.escalatorsCount),
            straightTrapezoidalSpecification: this.form.straightTrapezoidalSpecification,
            escalatorsTrapezoidalSpecification: this.form.escalatorsTrapezoidalSpecification,
            escalatorsRaisedHigh: Number(this.form.escalatorsRaisedHigh),
            straightRaisedHigh: Number(this.form.straightRaisedHigh),
            straightSpeed: Number(this.form.straightSpeed),
            escalatorsSpeed: Number(this.form.escalatorsSpeed),
            inPaul: this.form.inPaul,
            receiveCertificatesTime: this.form.receiveCertificatesTime
          },
          bidNotices : arr[0],
          acceptReports : arr[1],
          contractScaners: arr[2],
          images : arr[3],
          otherMaterials : arr[4]
        }
        this.$request.createOrUpdate(data).then(res=>{
          this.$message.success('保存成功')
          this.$router.go(-1)
        })
      })
    },
    uploadFiles(name){
      return new Promise((resolve, reject) => {
        const urlArr = []
        let i = 0
        const files = this.$refs[name].getFiles()
        if (!files.length){
          resolve(urlArr)
        }
        let flag = 0
        files.forEach(file => {
          if (file.show) {
            urlArr.push({fileUrl: file.fileUrl})
            i++
            if (i === files.length && flag === 0){
              resolve(urlArr)
            }

          } else {
            flag ++
            const formData = new FormData();
            formData.append('file',file.raw)
            this.$request.uploadFiles(formData).then(res => {
              urlArr.push({fileUrl: res.msg})
              i++
              flag--
              if (i === files.length){
                resolve(urlArr)
              }
            }).catch(err => {
              reject(err)
            })
          }
        })
      })
    }
  },
  beforeCreate() {
    document.body.setAttribute('style', 'background:#F4F4F5;')
  }
}
</script>

<style lang="less" scoped>
::v-deep .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  -webkit-box-shadow: 0 0 2px 2px #0000;
  box-shadow: 0 0 2px 2px #0000;
}
::v-deep .el-form-item__label{
  color: #000000;
  font-size: 16px;
}
.edit{
  margin-top: 48px;
  &>.form{
    display: flex;
    flex-wrap: wrap !important;
    ::v-deep .el-form-item__content{
      width: 378px;
    }
    &>.el-form-item:nth-child(2n){
      margin-left: 32px;
    }
  }
}
::v-deep .zhong .el-form-item__content{
  text-align: end;
}
::v-deep .el-upload--picture-card{
  float: left;
  height: 50px;
  width: 50px;
  border: 1px solid #E60027 ;
  background-color: white;
  &> i{
    position: absolute;
    top: 17px;
    left: 18px;
    font-size: 16px;
    color: #E60027 ;
  }
}
::v-deep .el-upload-list--picture-card{
  position: absolute;
  margin-left: 58px;
  &> .el-upload-list__item{
    height: 50px;
    width: 50px;
  }
}
.container {
  padding: 0 136px;

  .info-title {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    margin-top: 48px;
    &>.el-button{
      height: 32px;
    }
  }

  .proj-con {
    padding: 29px 24px 19px 24px;
    background-color: #fafafa;
    margin-top: 16px;
    margin-bottom: 50px;
    border-radius: 8px;

    ::v-deep .el-descriptions-item__cell {
      padding: 0 0 10px 0;
    }

    ::v-deep .el-descriptions__body {
      background-color: transparent;
    }

    ::v-deep .el-descriptions-item__content {
      color: #e60027;
    }
  }

  .upload-btn {
    display: none;
  }

  .doc-list {
    margin-top: 4px;
    display: flex;
    flex-wrap: wrap;
    padding-top: 20px;

    &>.item {
      flex: 0 0 240px;
      height: 220px;
      margin-right: 54px;
      margin-bottom: 20px;

      &:nth-child(3n) {
        margin-right: 0;
      }

      &>.img {
        width: 240px;
        height: 136px;
        border-radius: 12px;
        position: relative;
        box-sizing: border-box;
        overflow: hidden;
        border: 1px solid #eee;

        &.add {
          background: url('~@/assets/imgs/add-circle-fill@2x.png') no-repeat center center / 56px auto;
          background-color: #f0f0f0;
        }

        &>.type {
          width: 80px;
          height: 80px;
          transform: translate(-40px, -40px) rotate(-45deg);

          &.s1 {
            font-size: 12px;
            line-height: 20px;
            color: #fff;

            &::after {
              content: '已发布';
              display: block;
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 20px;
              background-color: #52c41a;
              text-align: center;
              box-sizing: border-box;
            }
          }

          &.s2 {
            font-size: 12px;
            line-height: 20px;
            color: #fff;

            &::after {
              content: '未发布';
              display: block;
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 20px;
              background-color: #d9d9d9;
              text-align: center;
              box-sizing: border-box;
            }
          }

          &.s3 {
            font-size: 12px;
            line-height: 20px;
            color: #fff;

            &::after {
              content: '线下文档';
              display: block;
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 20px;
              background-color: #52c41a;
              text-align: center;
              box-sizing: border-box;
            }
          }
        }

        // & > div {
        //   height: 55.18px;
        //   width: 55.18px;
        //   position: relative;
        //   position: absolute;
        //   left: 0;
        //   top: 0;
        //   &.unpub {
        //     background: url('~@/assets/imgs/pic_tag_unfinished@2x.png')
        //       no-repeat center center / 55.18px auto;
        //   }
        //   &.pub {
        //     background: url('~@/assets/imgs/pic_tag_complete@2x.png') no-repeat
        //       center center / 55.18px auto;
        //   }
        // }
        //&.selectable {
        //  cursor: pointer;
        //
        //  &::after {
        //    content: '';
        //    font-size: 12px;
        //    border-radius: 2px;
        //    position: absolute;
        //    right: 6px;
        //    top: 6px;
        //    width: 16px;
        //    height: 16px;
        //    background: rgba(0, 0, 0, 0.45);
        //  }
        //}

        //&.select {
        //  &::after {
        //    content: '✔';
        //    color: #fff;
        //    font-size: 12px;
        //    border-radius: 2px;
        //    position: absolute;
        //    right: 6px;
        //    top: 6px;
        //    width: 16px;
        //    height: 16px;
        //    background: #e60027;
        //    text-align: center;
        //  }
        //}
      }

      &>.imgurl {
        width: 240px;
        height: 136px;
      }

      &>.info-con {
        padding-top: 12px;

        &>div {
          color: rgba(0, 0, 0, 0.85);
        }

        &>p {
          padding-top: 5px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
          margin: 0;
        }
      }
    }
  }
}

.bott {
  display: flex;
  margin-top: 6px;
  height: 24px;
  align-items: center;

  &>.info {
    flex: 1;
    color: rgba(0, 0, 0, 0.45);

    &.publish {
      color: #52c41a;
    }
  }

  &>.edit-con {
    flex: 0 0 auto;

    &>i {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.45);
      cursor: pointer;
      margin: 0 5px;

      &:hover {
        color: #e60027;
      }

      &.el-icon-loading {
        cursor: default;
        color: rgba(0, 0, 0, 0.45);
      }
    }

    &>.eye {
      cursor: pointer;
      display: inline-block;
      background: url('~@/assets/imgs/icon_see_default@2x.png') no-repeat center center / 24px auto;
      height: 24px;
      width: 24px;
    }

    &>.download {
      cursor: pointer;
      display: inline-block;
      background: url('~@/assets/imgs/icon_download_default@2x.png') no-repeat center center / 24px auto;
      height: 24px;
      width: 24px;
    }

    &>.edit {
      display: inline-block;
      background: url('~@/assets/imgs/icon_edit_default@2x.png') no-repeat center center / 24px auto;
      height: 24px;
      width: 24px;
      cursor: pointer;
    }
  }
}

.ed {
  margin: 5px auto;
}
</style>
